module.exports = __webpack_public_path__ + "static/media/trello-logo-white.5a96655e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trello-logo-white.png
// module id = 242
// module chunks = 0